<template>
  <div>
    <v-row no-gutters>
      <span class="textLight--text font-weight-medium text-h5 text-start">
        {{ $vuetify.rtl ? " أهلاً" + name : "Hi " + name + "," }}
      </span>
    </v-row>

    <v-row no-gutters>
      <span class="textLight--text subtitle-1 text-start" style="opacity: 0.5">
        {{ $t("introVideoMessage") }}
      </span>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8">
        <VideoPlayer :mediaUrl="getVideo([introVideos])" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {
    VideoPlayer: () => import("../components/VideoPlayer"),
  },
  data() {
    return {
      loading: true,
      introVideos: null,
    };
  },
  computed: {
    name() {
      return this.$store.state.authenticatedUser?.firstName ?? "";
    },
  },
  apollo: {
    // getAppData() {
    //   return {
    //     query: require("../api/query/getAppData.gql"),
    //     result({ data, loading }) {
    //       if (data && data.getAppData && data.getAppData.appSettings) {
    //         // this.introVideos = data.getAppData.appSettings.introVideos;
    //       }

    //       this.loading = loading;
    //     },
    //   };
    // },
    getSubscriberProfile() {
      return {
        query: require("../../user-module/api/query/getSubscriberProfile.gql"),
        result({ data }) {
          if (data?.getSubscriberProfile?.introVideos?.length) {
            this.introVideos = data.getSubscriberProfile.introVideos[0];
          }
        },
      };
    },
  },
};
</script>
